import React  from 'react';

export const showRequired = (required) => {
  return required ? (
    <span className="required-fld">
      *
    </span>
  ) : null;
};


// WEBPACK FOOTER //
// ./src/libraries/form/formField/fields/utilities/showRequired.jsx